// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "@firebase/storage";
import { getAuth } from "firebase/auth";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBRsX2CsmPYypYKWP4QzkR054eZwtZ5oFI",
  authDomain: "mcsm-fa24se115.firebaseapp.com",
  projectId: "mcsm-fa24se115",
  storageBucket: "mcsm-fa24se115.appspot.com",
  messagingSenderId: "730633806343",
  appId: "1:730633806343:web:1407cc698ed9cf76e680a2",
  measurementId: "G-5HFJVLXEKC",
};
// Initialize Firebase
console.log('*** Firebase Config ***', firebaseConfig)

export const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const messaging = getMessaging(app);


export const getTokens = (setTokenFound) => {
  return getToken(messaging, { vapidKey: 'BNFbthn34wRB-XMkheaVcastNza4elNyTz813sYpFnDP0W3ETP8zajyRLmD0KEZ0DlULLhcg4nmKegXiz_-4-v8' })
    .then((currentToken) => {
    if (currentToken) {
      console.log('current token for client: ', currentToken);
      setTokenFound(true);
      window.localStorage.setItem("tokenNoti", JSON.stringify(currentToken));
      // Track the token -> client mapping, by sending to backend server
      // show on the UI that permission is secured
    } else {
      console.log('No registration token available. Request permission to generate one.');
      setTokenFound(false);
      // shows on the UI that permission is required 
    }
  }).catch((err) => {
    console.log('An error occurred while retrieving token. ', err);
    // catch error while creating client token
  });
}

// const requestForToken = async () => {
//   try {
//     const currentToken = await getToken(messaging, { vapidKey: 'BNFbthn34wRB-XMkheaVcastNza4elNyTz813sYpFnDP0W3ETP8zajyRLmD0KEZ0DlULLhcg4nmKegXiz_-4-v8' });
//     if (currentToken) {
//       console.log('Token retrieved: ', currentToken);
//     } else {
//       console.log('No token available');
//     }
//   } catch (error) {
//     console.log('Error retrieving token: ', error);
//   }
// };

// requestForToken();

// Listen for foreground messages
// onMessage(messaging, (payload) => {
//   console.log('Message received: ', payload);
//   // Handle the foreground message here
// });